// Every user-facing string on the booking confirmation, in one place.

export const BOOKING_CONFIRMATION_COPY = {
  kicker: "Call confirmed",
  titleTail: "call you",
  timeLineLead: "We'll call",
  addToCalendarLabel: "Add to my calendar",
  calendarOptions: {
    google: "Google Calendar",
    apple: "Apple Calendar",
    outlook: "Outlook",
  },
  calendarEventTitle: "Pre-planning call with After",
  hostHeading: "Who's calling",
  hostRole: "Licensed pre-planning agent",
  hostBio: "Here to answer your questions and walk you through your options.",
  expectHeading: "What to expect",
  expectPoints: [
    "About 15 minutes.",
    "No obligation. You don't have to decide anything on the call.",
    "Nothing to prepare or have on hand.",
  ],
  appBoxHeading: "Want to save time on the call?",
  appBoxBody: "Start your application now and it'll be ready when we talk.",
  appBoxCta: "Start my application",
  prepHeading: "Get the most from your call",
  prepSub: "Tap what's on your mind. We'll make sure your call covers it.",
  prepSaved: "Saved. We'll cover these on your call.",
  multiTag: "Pick any",
  videoHeading: "Why families plan ahead",
  videoQuote: "They make one phone call, and that's it.",
  videoMeta: "Watch · 1:46",
  videoLengthLabel: "video, 1 minute 46 seconds",
  videoClose: "Close video",
  reviewStarsLabel: "5 out of 5 stars",
  opensInNewTab: "(opens in a new tab)",
} as const;

export function bookingConfirmationTitleHead(hostFirst: string): string {
  return `${hostFirst} will`;
}

/** The calendar event's description — the server-side .ics builder words
 * it the same way. */
export function calendarEventDescription(
  hostFirst: string,
  phone: string | null,
): string {
  return `${hostFirst} from After will call ${phone ?? "you"}. About 15 minutes, no obligation, nothing to prepare.`;
}

export const PREP_QUESTIONS = [
  {
    id: "topics",
    question: "What's on your mind?",
    multi: true,
    options: [
      { value: "cost", label: "How much is it?" },
      { value: "monthly_payments", label: "Can I pay monthly?" },
      { value: "best_plan", label: "Which plan is best for me?" },
      { value: "family_contact", label: "Who does my family call?" },
      { value: "ashes", label: "What happens to my ashes?" },
      { value: "travel", label: "What if I'm traveling?" },
      { value: "money_safety", label: "Is my money safe?" },
      { value: "something_else", label: "Something else" },
    ],
  },
  {
    id: "decide",
    question: "Will anyone help you decide?",
    multi: false,
    options: [
      { value: "just_me", label: "Just me" },
      { value: "spouse_or_partner", label: "Spouse or partner" },
      { value: "children", label: "My children" },
      { value: "someone_else", label: "Someone else" },
    ],
  },
  {
    id: "have",
    question: "What do you already have?",
    multi: true,
    options: [
      { value: "nothing_yet", label: "Nothing yet" },
      { value: "other_quotes", label: "Getting other quotes" },
      { value: "life_insurance", label: "Life insurance" },
      { value: "prepaid_plan", label: "Another prepaid plan" },
      { value: "veteran_benefits", label: "Veteran benefits" },
      { value: "plot_or_niche", label: "Plot or niche" },
    ],
  },
] as const;
